import React, { useState, useRef, useEffect } from 'react';
import FreeFormFieldEditor from './FormElementEditors/FreeFormFieldEditor';
import RadioSingleSelectFieldEditor from './FormElementEditors/RadioSingleSelectFieldEditor';
import SingleSelectFieldEditor from './FormElementEditors/SingleSelectFieldEditor';
import MultiSelectFieldEditor from './FormElementEditors/MultiSelectFieldEditor';
import TextAreaFieldEditor from './FormElementEditors/TextAreaFieldEditor';
import StaticTextFormAttributeEditor from './FormElementEditors/StaticTextFormAttributeEditor';
import DatePickerFieldEditor from "./FormElementEditors/DatePickerFieldEditor";
import Collapse from 'react-bootstrap/Collapse';
import APP_CONSTANTS from '../../shared/constants/app_constants';
import FormAttributeApiService from '../services/FormAttributeApiService';
import {generateNameFromLabel} from '../../shared/form_attribute_utils';

function FADraggableEditor(props) {
  const formAttribute = props.formAttribute;
  const faApiService = new FormAttributeApiService(props.rails_authenticity_token);
  const [showLabelEditor, setShowLabelEditor] = useState(false);
  const [labelValue, setLabelValue] = useState(props.formAttribute.label);
  const labelInputRef = useRef();
  
  useEffect(() => {
    setLabelValue(formAttribute.label);
  }, [formAttribute.label]);

  const deleteFA = (e) => {
    props.onDeleteFormAttribute(formAttribute.id);
  }

  const faDataAsString = () => {
    return JSON.stringify({
      draggable_type: props.draggable_type,
      display_type: formAttribute.display_type,
      form_attribute_id: formAttribute.id
    });
  }

  const getFormAttributeLink = (type = "edit") => {
    const fa = formAttribute;
    let link = `/dashboard/editor/form_attributes/${fa.id}/`;
    if (type === "edit"){
      link += "edit";
    }
    return link;
  }

  const getFormAttributeElementForEditor = (formAttribute) => {
    let faState = Object.assign(formAttribute, {
      hidden: false,
      read_only: false,
      hide_label_flag: true,
      bootstrapVersion: 4
    });
    let faElement;
    let initialValue = null;
    switch (faState.display_type) {
      case APP_CONSTANTS.DISPLAY_TYPES_HTML.TEXT:
      case APP_CONSTANTS.DISPLAY_TYPES_HTML.EMAIL:
      case APP_CONSTANTS.DISPLAY_TYPES_HTML.NUMBER:
        if (faState.default_value && faState.default_value.length > 0) {
          initialValue = faState.default_value;
        } else {
          initialValue = "";
        }
        faElement = <FreeFormFieldEditor
          {...faState}
          onChangeFunctionCall={() => {console.log('change input')}}
          onBlurFunctionCall={() => {console.log('on blur')}}
          onUpdateLabel={(labelVal) => {console.log('update the label to ', labelVal)}}
          onUpdateFormAttribute={props.updateFormAttributeValue}
          defaultValue={initialValue}
          key={faState.id} />;
        break;
      case APP_CONSTANTS.DISPLAY_TYPES_HTML.TEXTAREA:
        // TODO: fix initial value
        if (faState.default_value && faState.default_value.length > 0) {
          initialValue = faState.default_value;
        } else {
          initialValue = "";
        }
        faElement = <TextAreaFieldEditor
          {...faState}
          onChangeFunctionCall={() => {console.log('change input')}}
          onBlurFunctionCall={() => {console.log('on blur')}}
          value={undefined}
          defaultValue={initialValue}
          key={faState.id} />;
        break;
      case APP_CONSTANTS.DISPLAY_TYPES_HTML.SELECT:
        faElement = <SingleSelectFieldEditor
          {...faState}
          onChangeFunctionCall={() => {console.log('change input')}}
          value={faState.default_value}
          key={faState.id} />;
        break;
      case APP_CONSTANTS.DISPLAY_TYPES_HTML.RADIO:
        // does this work?
        faElement = <RadioSingleSelectFieldEditor
          {...faState}
          onChangeFunctionCall={() => {console.log('change input')}}
          value={undefined}
          defaultValue={null}
          key={faState.id} />;
        break;
      case APP_CONSTANTS.DISPLAY_TYPES_HTML.CHECKBOX:
        // TODO: do we need a default value here? 
        faElement = <MultiSelectFieldEditor
          {...faState}
          onChangeFunctionCall={() => {console.log('change input')}}
          value={undefined}
          defaultValue={[]}
          key={faState.id} />;
        break;
      //case APP_CONSTANTS.DISPLAY_TYPES_HTML.STATIC_TEXT: //TODO: to be removed
      case APP_CONSTANTS.DISPLAY_TYPES_HTML.STATIC_HTML:
        const value = (!!faState.default_value && faState.default_value.length > 0 
          ? faState.default_value : '&lt;Static HTML&gt;');
        faElement = <StaticTextFormAttributeEditor
          {...faState}
          value={value}
          key={faState.id} />;
        break;
      case APP_CONSTANTS.DISPLAY_TYPES_HTML.INLINE_STYLE:
        // dont render this FA type
        break;
      case APP_CONSTANTS.DISPLAY_TYPES_HTML.DATEPICKER:
        // TODO: add datepicker editor
        faElement = <DatePickerFieldEditor          
          {...faState}
          value={undefined}
          onChangeFunctionCall={(data) => {console.log('do nothing with', data)}}
          key={faState.id} />;
        break;
      case APP_CONSTANTS.DISPLAY_TYPES_HTML.RATING_SCALE:
        // TODO: under constuction
        faElement = <div>Rating scale component</div>;
        break;
      default:
        faElement = <div className='h-3'>this form attribute element is missing!</div>;
    }
    return faElement;
  }

  const saveLabel = () => {
    const updatedLabelValue = labelInputRef.current.value;
    const formAttributeData = {
      label: updatedLabelValue
    };
    const thisFormAttribute = props.formAttribute;
    if (thisFormAttribute.deleteable) { // TODO AND it matches old label then reset it
      const expectedName = generateNameFromLabel(thisFormAttribute.label);
      if (expectedName === thisFormAttribute.name) {
        const faName = generateNameFromLabel(updatedLabelValue);
        formAttributeData.name = faName;
      } else {
        // console.log('it appears this fa name was edited, leave as is');
      }
    }
    faApiService.updateFormAttribute(props.formAttribute.id, props.formAttribute.keenform_id, formAttributeData)
      .then((response) => {
        console.log('RESPONSE FROM save label in fa draggable editor', response);
        setShowLabelEditor(false);
        setLabelValue(response.label);
      })
      .catch ( (error) => {
        console.error('error in updating label for FA');
        console.error(error);
      });
  }

  const getInPlaceLabelEditor = (faProps) => {
    const buttonIconClass = showLabelEditor ? 'fa-xmark' : 'fa-pen-to-square';
    return (
      <div>
        { showLabelEditor
          ? <input 
              type="text"
              className="input-as-label-editor"
              ref={labelInputRef}
              defaultValue={labelValue} />
          : <label 
                className="kf-fa-label form-label mirror-input"
                htmlFor={`${faProps.name}`}>
                {labelValue}
                {faProps.required && "*"}
            </label>
        }
        {
          showLabelEditor && <button onClick={saveLabel}
            type="button" 
            className="btn btn-outline-success btn-sm">save</button>
        }
        <button 
          onClick={toggleLabelEditor}
          type="button" 
          className="btn btn-outline-secondary btn-sm">
          <i className={`fa-solid ${buttonIconClass}`}></i>
        </button>
      </div>);
  }

  const toggleLabelEditor = () => {
    setShowLabelEditor(!showLabelEditor);
  };

  const faProps = {
    ...props.formAttribute,
    hide_label_flag: true
  };

  const newFAClass   = (formAttribute.new ? "new-fa" : "");
  const visibleClass = formAttribute.hidden ? "fa-hidden" : "fa-visible";
  const deleteButton = (formAttribute.deleteable === true && props?.keenform?.freeze_editing === false
    ? <button className="btn btn-danger btn-circle m-1 float-right" title="delete" onClick={deleteFA}>
      <i className="fas fa-trash-alt"></i>
    </button>
    : <button className="btn btn-disabled btn-circle m-1 float-right" disabled="disabled">
        <i className="fas fa-ban"></i>
      </button>
  );

  return (
    <Collapse in={!formAttribute.deleted}>
      <div
        key={formAttribute.uuid}
        id={formAttribute.uuid}
        data-id={formAttribute.uuid}
        className={`clearfix form-attribute-editor draggable ${newFAClass} ${visibleClass}`}
        data-fa-object={faDataAsString()}>
        <div className="fa-editor-container">
          <div className="fa-editor-subcontainer">
            <div className="row">
              <div className="col-md-8 col-sm-6 fa-form-element-col">
                {getInPlaceLabelEditor(faProps)}
                {formAttribute.hidden && <span>(hidden)</span>}
                {getFormAttributeElementForEditor(faProps)}
              </div>
              <div className="col-md-4 col-sm-6 fa-actions-col">
                <div className="drag-handle drag-handle-fa-editor drag-handle-background float-right">
                </div>
                { deleteButton }
                <a href={getFormAttributeLink()} className={`btn btn-circle m-1 float-right ${props?.keenform?.freeze_editing ? 'disabled' : 'btn-warning'}`} title="edit">
                  <i className="fas fa-edit"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Collapse>
  );
}

export default FADraggableEditor;
